import { AbstractControl, ValidationErrors } from "@angular/forms";

export function bicValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null; // Don't validate empty values to allow optional fields
  }

  const bic = control.value.toString().trim();

  // Remove all spaces and convert to uppercase
  const cleanedBIC = bic.replace(/\s/g, "").toUpperCase();

  // BIC format: 4 letters (bank) + 2 letters (country) + 2 alphanumeric (location) + 3 alphanumeric (branch, optional)
  // Total length: 8 or 11 characters
  const bicFormatRegex = /^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/;

  if (!bicFormatRegex.test(cleanedBIC)) {
    return { bic: true };
  }

  // Validate length (must be exactly 8 or 11 characters)
  if (cleanedBIC.length !== 8 && cleanedBIC.length !== 11) {
    return { bic: true };
  }

  return null;
}
